// extracted by mini-css-extract-plugin
module.exports = {"button":"ChosenButton_button_2Ifwx","small":"ChosenButton_small_zb8Wl","chosen":"ChosenButton_chosen_1NGxL","mobileButton":"ChosenButton_mobileButton_mGO--"};